import { identity } from "@thi.ng/compose";
import { push } from "../rfn/push";
/**
 * Shared helper function for `groupBy*` reducers
 *
 * @param opts -
 *
 * @internal
 */
export const __groupByOpts = (opts) => (Object.assign({ key: identity, group: push() }, opts));
